export default __webpack_public_path__ + "static/media/serv3.3e53752a.png";